export const environment = {
  production: true,
  environmentName: 'demo',
  applicationKey: '1b4cdeed-e8b3-4a12-8bca-ee2b572e6d77',
  baseUrl: 'https://dev.verbalize.ai/admin/api/v1',
  mediaUrl: 'https://verbalize-staticcontent-endpoint-dehaechkercsf6dw.a03.azurefd.net/media/',
  documentUrl: 'https://verbalize-staticcontent-endpoint-dehaechkercsf6dw.a03.azurefd.net/documents/',
  auth0Domain: 'dev-ut9hcoi3.auth0.com',
  auth0Audience: 'https://verbalize.ai/admin-api',
  // auth0ClientId: 'igg3JT5YzHZpoGwBPsO6HWokwVX1suRZ',
  auth0ClientId: '4xABntycLQF701ytPQO4oL42TOIGlRsD',
  rolesKey: 'https://dev.verbalize.ai/roles',
  rstudioUrl: 'https://rstudio.scalable.care',
  rstudioEnabled: true
};
